<template>
    <div v-if="status === 'user-success'">
        <!-- core  -->
        <kt-nav space="md" size="lg" id="kt-nav" >
            <kt-nav-item class="no-bullet">
                <div class="accordion accordion-toggle-arrow" id="accounting_info">
                    <div class="card" style="overflow:inherit">
                        <div class="card-header bg-transparent" id="headingOne">
                            <div class="card-title collapsed" data-toggle="collapse"
                                 data-target="#CoreAccountingForm"
                                 aria-controls="CoreAccountingForm">
                                {{ $t('reports.users.core_accounting_info') }}
                            </div>
                        </div>
                        <div id="CoreAccountingForm" class="collapse" aria-labelledby="CoreAccountingForm" data-parent="#accounting_info">
                            <div class="card-body">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="12" md="12">
                                            <ul>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.total_transactions')}} :
                                                    {{userCoreAccountingStatistics.total_transactions}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li >
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.total_wage')}} :
                                                    {{userCoreAccountingStatistics.total_wage}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.unsettled_balance')}} :
                                                    {{userCoreAccountingStatistics.total_balance}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.settled_balance')}} :
                                                    {{userCoreAccountingStatistics.settled_amount}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                            </ul>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                            </div>
                        </div>
                    </div>
                </div>
            </kt-nav-item>

            <!-- starshop -->
<!--            <kt-nav-item class="no-bullet">-->
<!--                <div class="accordion accordion-toggle-arrow" id="accounting_info">-->
<!--                    <div class="card" style="overflow:inherit">-->
<!--                        <div class="card-header bg-transparent" id="headingOne">-->
<!--                            <div class="card-title collapsed" data-toggle="collapse"-->
<!--                                 data-target="#starshopAccountingForm"-->
<!--                                 aria-controls="starshopAccountingForm">-->
<!--                                 {{ $t('reports.users.starshop_accounting_info') }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div id="starshopAccountingForm" class="collapse" aria-labelledby="starshopAccountingForm" data-parent="#accounting_info">-->
<!--                            <div class="card-body">-->
<!--                                <kt-form-section>-->
<!--                                    <kt-form-row>-->
<!--                                        <kt-col xs="12" sm="12" md="12">-->
<!--                                            <ul>-->
<!--                                                <li class="mt-3">-->
<!--                                                    {{$t('reports.gateways.total_transactions')}} :-->
<!--                                                    {{userStarshopAccountingStatistics.total_transactions}}-->
<!--                                                    <span>{{' ' + $t('currency.rial')}}</span>-->
<!--                                                </li >-->
<!--                                                <li class="mt-3">-->
<!--                                                    {{$t('reports.gateways.total_wage')}} :-->
<!--                                                    {{userStarshopAccountingStatistics.total_wage}}-->
<!--                                                    <span>{{' ' + $t('currency.rial')}}</span>-->
<!--                                                </li>-->
<!--                                                <li class="mt-3">-->
<!--                                                    {{$t('reports.gateways.unsettled_balance')}} :-->
<!--                                                    {{userStarshopAccountingStatistics.total_balance}}-->
<!--                                                    <span>{{' ' + $t('currency.rial')}}</span>-->
<!--                                                </li>-->
<!--                                                <li class="mt-3">-->
<!--                                                    {{$t('reports.gateways.settled_balance')}} :-->
<!--                                                    {{userStarshopAccountingStatistics.settled_amount}}-->
<!--                                                    <span>{{' ' + $t('currency.rial')}}</span>-->
<!--                                                </li>-->
<!--                                            </ul>-->
<!--                                        </kt-col>-->
<!--                                    </kt-form-row>-->
<!--                                </kt-form-section>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </kt-nav-item>-->

            <kt-nav-item>
                <div class="accordion accordion-toggle-arrow" id="login_info">
                <div class="card" style="overflow:inherit">
                    <div class="card-header bg-transparent" id="headingTwo">
                        <div class="card-title collapsed" data-toggle="collapse"
                             data-target="#loginForm"
                             aria-controls="loginForm">
                            {{ $t('reports.users.login_info') }}
                        </div>
                    </div>
                    <div id="loginForm" class="collapse" aria-labelledby="loginForm" data-parent="#login_info">
                        <div class="card-body">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="12" md="12">
                                        <ul>
                                            <li v-if="userLoginStatistics.user_level===1" class="mt-3">
                                                {{$t('reports.users.user_level')}} :
                                                {{$t('customers_club.l1')}}
                                            </li >
                                            <li v-else-if="userLoginStatistics.user_level===2" class="mt-3">
                                                {{$t('reports.users.user_level')}} :
                                                {{$t('customers_club.l2')}}
                                            </li >
                                            <li v-else-if="userLoginStatistics.user_level===3" class="mt-3">
                                                {{$t('reports.users.user_level')}} :
                                                {{$t('customers_club.l2')}}
                                            </li >
                                            <li v-else class="mt-3">
                                                {{$t('reports.users.user_level')}} :
                                                {{$t('customers_club.null')}}
                                            </li >
                                            <li class="mt-3">
                                                {{$t('reports.users.created_at')}} :
                                                {{userLoginStatistics.created_at}}
                                            </li>
                                            <li class="mt-3">
                                                {{$t('reports.users.last_update')}} :
                                                {{userLoginStatistics.last_update}}
                                            </li>
                                            <li class="mt-3">
                                                {{$t('reports.users.last_ip_login')}} :
                                                {{userLoginStatistics.last_ip_login}}
                                            </li>
                                        </ul>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                        </div>
                    </div>
                </div>
            </div>
            </kt-nav-item>
        </kt-nav>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {

    computed: {
        ...mapGetters('reports', [
            "userCoreAccountingStatistics", "userStarshopAccountingStatistics", 'userLoginStatistics','status'
        ])
    },

    mounted() {
        this.$store.dispatch('reports/userStarshopAccountingInfo', this.$route.params.hashid)
        this.$store.dispatch('reports/userCoreAccountingInfo', this.$route.params.hashid)
        this.$store.dispatch('reports/userLogin', this.$route.params.hashid)
        
    }
}
</script>